import { Button, Card } from 'react-bootstrap';
import AppLoader from 'components/general/AppLoader';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useSelector } from 'react-redux';

export default function AgendaItemDeleteModal({ item, getMeeting, handleClose }) {
    const { user: authUser } = useSelector(x => x.auth);

    const url = process.env.REACT_APP_URL;
    const [saveLoading, setSaveLoading] = useState(false);

    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        const confirmed = window.confirm('Are you sure you want to delete this agenda item?');
        if (!confirmed) return;
        setSaveLoading(true);

        try {
            const response = await fetch(`${url}/agendaItem/${item.agendaItemId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authUser.token}`,
                },
            });

            if (response.status !== 200) {
                throw new Error(`(${response.status}) We could not delete the Agenda Item ${item.agendaEvent?.name}`);
            }

            setSaveLoading(false);
            getMeeting(); // Refresh the meeting data after deletion
            handleClose(); // Close the modal
        } catch (err) {
            toast.error(`${err}`, { position: 'bottom-left' });
            setSaveLoading(false);
        }
    };

    return (
        <Card className='my-2 p-3'>
            <Card.Header>
                <span className='d-inline-flex align-items-center gap-2'>
                    <Button
                        variant='danger'
                        size='sm'
                        className='p-1'
                        type='button'
                        onClick={handleSubmit}
                        aria-label='Delete agenda item'
                        title='Delete agenda item'
                        disabled={saveLoading}
                    >
                        <i className='bi bi-trash'></i>
                    </Button>
                    <span>Delete Agenda Item</span>
                </span>
            </Card.Header>
            <Card.Body className="text-center">
                <h2>Delete Agenda Item:</h2>
                <h4>{item.agendaEvent?.name}</h4>
            </Card.Body>
            <Card.Footer>
                {saveLoading ? (
                    <>
                        <AppLoader />
                    </>
                ) : (
                    <>
                        <Button variant="dark" onClick={handleClose} type="button">
                            <i className='bi bi-x-lg'></i>
                        </Button>
                    </>
                )}
            </Card.Footer>
        </Card>
    );
}
